import { Disclosure } from "@portal/components/patterns";
import { Text } from "@portal/components/primitives";
import {
	type AssistantToolCall,
	assistantSourcesSummary,
	assistantToolDetail,
	assistantToolLabel,
} from "./assistantCopy";

/**
 * The trail behind an answer, collapsed to one row. Each tool call names the data it read and
 * what came back, so a number in the answer can be traced without reading the transcript.
 */
export const AdminAssistantSources = ({ toolCalls }: { toolCalls: AssistantToolCall[] }) => {
	if (toolCalls.length === 0) return null;

	return (
		<Disclosure testId="assistant-sources">
			<Disclosure.Summary testId="assistant-sources-summary">
				{assistantSourcesSummary(toolCalls.length)}
			</Disclosure.Summary>
			<Disclosure.Panel>
				{toolCalls.map((toolCall, index) => {
					const detail = assistantToolDetail(toolCall);
					return (
						<Disclosure.Row
							key={`${toolCall.toolName}-${index}`}
							testId="assistant-source-row"
							trailing={
								detail === undefined ? undefined : (
									<Text color={toolCall.isError ? "danger" : "tertiary"} type="caption">
										{detail}
									</Text>
								)
							}
						>
							<Text className="min-w-0" color="secondary" truncate type="caption">
								{assistantToolLabel(toolCall.toolName)}
							</Text>
						</Disclosure.Row>
					);
				})}
			</Disclosure.Panel>
		</Disclosure>
	);
};
